// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2796": "1220649ff1ef","3562": "eb015d7d9b09","5687": "ed42304901a9","5884": "77199dfa1e52","6863": "454c9f289029","7008": "21e09423e6b5","9064": "b796361dca81","9443": "c98ddb5f019d",}[chunkId] + ".css"
}